export const fillArray = (arr: string[]) => {
  if (!arr || arr === undefined || arr === null || arr.length < 1) {
    return (arr = ["1", "2", "3", "4", "5"]);
  }
  while (arr.length < 5) {
    arr = arr.concat(arr);
  }

  return arr.slice(0, 5);
};

export const arrayFilterAndUnfilteredByWorkspaces = (dataArray, filters) => {
  const { minPeople = null, workspaceType = [] } = filters;

  const workspaceTypeSet =
    workspaceType.length > 0
      ? new Set(workspaceType.map(type => type?.toLowerCase()))
      : null;

  const filteredData = [];
  const unFilteredData = [];

  dataArray.forEach(item => {
    const spaceTypeFormulaLower = item?.spaceTypeFormula?.toLowerCase(); // Filter by minPeople if it's set
    const isMinPeopleValid =
      minPeople !== null ? item.noOfWS >= parseFloat(minPeople) : true; // Filter by workspaceType if it's set
    const isWorkspaceTypeValid =
      workspaceTypeSet !== null
        ? workspaceTypeSet.has(spaceTypeFormulaLower)
        : true; // Check if both conditions are valid
    const isValid = isMinPeopleValid && isWorkspaceTypeValid;

    if (isValid) {
      filteredData.push(item);
    } else {
      unFilteredData.push(item);
    }
  });

  return { filteredData, unFilteredData };
};

export function getAllIds(items = []) {
  const ids: string[] = [];

  items?.forEach((section) => {
    if (section?.id) {
      ids.push(section.id);
    }

    // safely handle subSections
    if (Array.isArray(section?.subSections)) {
      section.subSections.forEach((sub) => {
        if (sub?.id) {
          ids.push(sub.id);
        }
      });
    }
  });

  return ids;
}

export const getIndexDataByValue = (arr, val) =>
  arr.find(opt => opt.value === val);

export const getAverageCostPerWorkstation = (
  array: { costPerWorkstation?: number, avgMonthlyCostPerWorkstation?: number }[],
  type?: 'superior' | 'premium' | 'economical',
  spaceType?: string,
  area?: number,
  areaType?: 'sm' | 'sf'
): number => {
  if (!Array.isArray(array) || !array.length) return 0;

  let total = array.reduce((acc, item) => acc + (item.costPerWorkstation || item.avgMonthlyCostPerWorkstation || 0), 0);
  let average = total / array.length;

  // NEW LOGIC for non-desk space types
  if (spaceType && spaceType !== "desks" && area && areaType) {
    if (areaType === "sm") {
      average = average / 3;
    } else if (areaType === "sf") {
      average = average / 32.30;
    }
  }

  // Multipliers remain the same
  if (type === 'premium') {
    average *= 1.25; // add 25%
  } else if (type === 'economical') {
    average *= 0.85; // reduce by 15%
  }
  // For 'superior' or undefined, just leave the average as is

  return Math.ceil(average);
};